// Utils
import Portfolio from '@/types/portfolio';
import {
  calculatePercentGrowth,
  calculateCalendarYearReturns,
  calculateBestWorstPerformance,
  calculateUpDownMonths,
  calculateTrailingReturns,
  calculateCalendarYearFromRolling,
} from '../calculation-utils';
import Holding from '@/types/holding';
import Timestamp from '@/types/timestamp';
import PortfolioPerformance from '@/types/portfolio-performance';

/**
 * Calculate performance
 * @param {Portfolio} portfolio Portfolio to be calculated.
 * @param {Holding[]} data Funds and Stocks data.
 * @param {[Timestamp, number][]} monthlyRolling the monthly rolling performance for the portfolio
 * @param {boolean} shortHistory if the performance should be calculated with short history
 * @returns `PortfolioPerformance` Calculated portfolio performance.
 */
const calculatePerformance = (
  portfolio: Portfolio,
  data: Holding[],
  monthlyRolling: [Timestamp, number][],
  taxRate: number,
  forcedMonthlyRolling: boolean,
  shortHistory?: boolean,
): PortfolioPerformance => {
  const useRolling = portfolio.isPartiallyOverriden || forcedMonthlyRolling;
  const percentGrowth = useRolling ? calculateTrailingReturns(monthlyRolling) : calculatePercentGrowth(portfolio, data, taxRate, shortHistory);
  // for portfolios, we do not show INC
  percentGrowth.INC = null;

  return {
    percentGrowth,
    calendarYear: useRolling ? calculateCalendarYearFromRolling(monthlyRolling) : calculateCalendarYearReturns(portfolio, data, taxRate, shortHistory),
    bestWorst: calculateBestWorstPerformance(monthlyRolling),
    upDownMonths: calculateUpDownMonths(monthlyRolling.map(mr => mr[1])),
  };
};

export default calculatePerformance;
